import React from 'react';
import dayjs from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime';
import { CellRendererProps } from '../../DataTable.types';
import { LastStatusUpdateDisplay } from '../../../../../types/statusTimeline';
import styles from './LastStatusUpdateCellRenderer.module.scss';
import { slantArrowPurple } from '../../../../../assets/hostedassets';

dayjs.extend(relativeTime);

export const LastStatusUpdateCellRenderer: React.FC<CellRendererProps> = ({ value, row, column, dynamicProps }) => {
    const { onStatusTimelineClick } = dynamicProps || {};

    // Parse the last status update data
    const timestamp: LastStatusUpdateDisplay = value;

    if (!timestamp) {
        return <div className={styles.NoUpdate}>-</div>;
    }

    // Format the timestamp for display
    const formattedTimestamp = dayjs(timestamp).format('h:mm A, DD MMM YYYY');

    // Calculate relative time
    const displayElapsedTime = dayjs(timestamp).fromNow();

    const handleClick = (e: React.MouseEvent) => {
        e.stopPropagation();
        e.preventDefault();
        if (!row?._isCollapsibleRow && onStatusTimelineClick && !column?.disable) {
            onStatusTimelineClick(row);
        }
    };

    return (
        <div className={styles.LastStatusUpdate} onMouseDown={handleClick}>
            <div className={styles.StatusContent}>
                <div className={styles.Timestamp}>
                    {!column?.disable && <img src={slantArrowPurple} alt="slantArrowPurple" height={12} width={12} />}
                    <span>{formattedTimestamp}</span>
                </div>
                <div className={styles.ElapsedTime}>{displayElapsedTime}</div>
            </div>
        </div>
    );
};
